<template>
  <vue-scroll class="page-headers" :class="{ 'bottom-border': isBorder }">
    <div class="flex">
      <div class="box flex column">
        <el-breadcrumb class="box" separator="/">
          <el-breadcrumb-item class="subtitle1" v-for="crumb in breadcrumbs" :key="crumb.title" :to="crumb.to">{{
            crumb.title
          }}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="box">
          <h2>
            <div class="display-inline-block">
              <slot name="title-left-icon"></slot>
            </div>
            {{ header }}
            <el-link v-if="documentation" @click="loadDocumentation(documentation)" :underline="false">
              <i class="material-icons">help_outline</i>
            </el-link>
            <div class="display-inline-block">
              <slot name="title-right-icon"></slot>
            </div>
            <el-tag v-if="warning" size="medium" type="danger" class="warning">{{ warning }}</el-tag>
            <div class="display-inline-block">
              <slot name="title-links"></slot>
            </div>
          </h2>
        </div>
      </div>
      <div class="box grow">
        <slot name="actions"></slot>
      </div>
    </div>
  </vue-scroll>
</template>

<script>
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'
export default {
  name: 'PageHeaders',
  mixins: [loadDocumentationMixin],
  props: {
    header: {
      default: null,
      type: [String, Object]
    },
    subheader: {
      default: null,
      type: [String, Object]
    },
    documentation: {
      default: null,
      type: [String]
    },
    breadcrumbs: {
      default: function () {
        return []
      },
      type: [Array, Object]
    },
    isBorder: {
      default: false,
      type: [String, Boolean]
    },
    warning: {
      default: false,
      type: [String, Boolean]
    }
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

>>> .el-link.el-link--default {
  color: #c6cbd2;

  .material-icons {
    font-size: 20px;
  }
}

.warning {
  position: relative;
  top: -6px;
  left: 10px;
  text-transform: uppercase;
}

.bottom-border {
  border-bottom: 1px solid var(--border-color);
  padding-bottom: 15px;
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/PageHeaders.vue